/**
 * @generated SignedSource<<cf35d4dc5bd9230cfed3fb7e34de56f2>>
 * @relayHash 4f219d364f724ca6ff793e8cf6fb8247
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7d033fdc45ee11b13a40b69a614b887f1c9ec4b899a6cc41bf56b959b69d8787

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalAccessPermissionsSettingsAggQuery$variables = {
  containerId: string;
  isM3GroupPermsEnabled: boolean;
};
export type GoalAccessPermissionsSettingsAggQuery$data = {
  readonly DefaultGoalAccessLevelSection: {
    readonly " $fragmentSpreads": FragmentRefs<"DefaultGoalAccessLevelSection">;
  };
  readonly GoalGroupPermissionsSettings?: {
    readonly " $fragmentSpreads": FragmentRefs<"GoalGroupPermissionsSettings">;
  } | null;
};
export type GoalAccessPermissionsSettingsAggQuery = {
  response: GoalAccessPermissionsSettingsAggQuery$data;
  variables: GoalAccessPermissionsSettingsAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isM3GroupPermsEnabled"
  }
],
v1 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GoalAccessPermissionsSettingsAggQuery",
    "selections": [
      {
        "fragment": {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": (v2/*: any*/),
              "kind": "FragmentSpread",
              "name": "DefaultGoalAccessLevelSection"
            }
          ],
          "type": "Query"
        },
        "kind": "AliasedInlineFragmentSpread",
        "name": "DefaultGoalAccessLevelSection"
      },
      {
        "condition": "isM3GroupPermsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "GoalGroupPermissionsSettings"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "GoalGroupPermissionsSettings"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoalAccessPermissionsSettingsAggQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "TownsquareGoalsAppSettings",
        "kind": "LinkedField",
        "name": "goals_appSettings",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "defaultGoalAccessLevel"
          }
        ]
      },
      {
        "condition": "isM3GroupPermsEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "TownsquareGoalAppCapabilities",
            "kind": "LinkedField",
            "name": "goals_capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canRemoveAppLevelPermissions"
              }
            ]
          },
          {
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 100
              }
            ],
            "concreteType": "TownsquareGoalsAppPermissionPolicyConnection",
            "kind": "LinkedField",
            "name": "goals_appPermissionPolicies",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalsAppPermissionPolicyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalsAppPermissionPolicy",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "scopedGroupId"
                      },
                      {
                        "concreteType": "IdentityGroup",
                        "kind": "LinkedField",
                        "name": "group",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          (v3/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isDefaultGroup"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isEditable"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "userCount"
                      },
                      {
                        "concreteType": "TownsquareProductRole",
                        "kind": "LinkedField",
                        "name": "productRoles",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "role"
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoalsAppPermissionEntry",
                        "kind": "LinkedField",
                        "name": "appPermissions",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "permission"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isPermitted"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "4f219d364f724ca6ff793e8cf6fb8247",
    "id": "7d033fdc45ee11b13a40b69a614b887f1c9ec4b899a6cc41bf56b959b69d8787",
    "metadata": {},
    "name": "GoalAccessPermissionsSettingsAggQuery",
    "operationKind": "query",
    "text": "query GoalAccessPermissionsSettingsAggQuery(\n  $containerId: ID!\n  $isM3GroupPermsEnabled: Boolean!\n) {\n  ...DefaultGoalAccessLevelSection_1GKbF9\n  ...GoalGroupPermissionsSettings_1GKbF9 @include(if: $isM3GroupPermsEnabled)\n}\n\nfragment DefaultGoalAccessLevelSection_1GKbF9 on Query {\n  goals_appSettings(containerId: $containerId) @optIn(to: \"Townsquare\") {\n    defaultGoalAccessLevel\n  }\n}\n\nfragment GoalGroupPermissionsSettings_1GKbF9 on Query {\n  goals_capabilities(containerId: $containerId) {\n    canRemoveAppLevelPermissions\n  }\n  goals_appPermissionPolicies(containerId: $containerId, first: 100) @optIn(to: \"Townsquare\") {\n    edges {\n      node {\n        id\n        scopedGroupId\n        group {\n          name\n          id\n        }\n        isDefaultGroup\n        isEditable\n        userCount\n        productRoles {\n          role\n        }\n        appPermissions {\n          permission\n          isPermitted\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "175d8df7dddf327394bd83e39819336b";

export default node;
